export default "__VITE_ASSET__d16c99b8__"